// extracted by mini-css-extract-plugin
module.exports = {"review":"Users_review__3rOV3"};